import React from 'react'
import { Col, Container, Placeholder, Row } from 'react-bootstrap'

export const RerunPlaceholder: React.FC = () => {
  return (
    <Container className='mx-0 w-100 mw-100 p-0'>
      <Row className='p-0'>
        <Placeholder className='p-0 rerun-placeholder' as={Col} animation={'wave'}>
          <Placeholder xs={12} bg={'light'} />
        </Placeholder>
      </Row>
    </Container>
  )
}
